import { cn } from "@/utils/utils"
import { Spinner } from "@/components/ui/spinner"

type PageLoadingProps = {
  title?: string
  description?: string
  className?: string
}

function PageLoading({
  title = "Carregando",
  description = "Aguarde um momento enquanto a página é carregada.",
  className,
}: PageLoadingProps) {
  return (
    <div
      className={cn(
        "flex min-h-[16rem] flex-col items-center justify-center rounded-lg border border-border bg-background/60 p-8 text-center",
        className,
      )}
    >
      <Spinner className="mb-4 h-10 w-10 text-primary" />
      <p className="text-lg font-semibold">{title}</p>
      <p className="mt-2 text-sm text-muted-foreground max-w-xs">{description}</p>
    </div>
  )
}

export { PageLoading }
